import { render, staticRenderFns } from "./Rekisteroi-kayttaja.vue?vue&type=template&id=c9effe5a&"
import script from "./Rekisteroi-kayttaja.vue?vue&type=script&lang=js&"
export * from "./Rekisteroi-kayttaja.vue?vue&type=script&lang=js&"
import style0 from "./Rekisteroi-kayttaja.vue?vue&type=style&index=0&id=c9effe5a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports